import React from 'react';
import { translate } from 'react-i18next';
import FieldGroup from '../field_group/FieldGroup';
import Form from '../form/Form';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';

export class SolarEnergyDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  getRenewableEnergyData() {
    return this.formRef.getFormData();
  }

  render() {
    const {
      name,
      efficiency,
      area,
      power,
      description,
      image,
    } = this.props.renewableEnergy;

    const { disabled, fieldErrors, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => this.formRef = ref}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="solar-energy-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('solar energy name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="solar-energy-efficiency"
          field="efficiency"
          type="number"
          label={<span>{t('efficiency')} (%)</span>}
          placeholder="80"
          value={efficiency}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'efficiency')}
          {...customAttr}
        />
        <FieldGroup
          id="solar-energy-area"
          field="area"
          type="number"
          label={<span>{t('area')} ({t('sq m')})</span>}
          placeholder="80"
          value={area}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'area')}
          {...customAttr}
        />
        <FieldGroup
          id="solar-energy-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

SolarEnergyDetail.defaultProps = {
  renewableEnergy: {},
};

export default translate('translations', { withRef: true })(SolarEnergyDetail);



// WEBPACK FOOTER //
// ./src/components/renewable_energy/SolarEnergyDetail.js